import Image from "next/image";
import { PROBLEMS, SECTION_IDS } from "./content";
import { Reveal } from "./reveal";

export const Problem = () => (
  <section
    id={SECTION_IDS.problem}
    className="relative overflow-hidden px-[clamp(16px,4vw,64px)] py-[clamp(96px,14vw,210px)]"
  >
    <div className="absolute inset-0 z-0">
      <Image
        src="/images/separator-1.webp"
        alt=""
        fill
        sizes="100vw"
        className="object-cover opacity-[.42] saturate-[.8]"
      />
      {/* Kept dark top-left behind the headline, lifting towards the right and
          bottom so the imagery reads without competing with the copy. */}
      <div className="absolute inset-0 bg-[radial-gradient(120%_90%_at_18%_0%,rgba(3,12,22,.72),rgba(3,12,22,.5)_58%,rgba(3,12,22,.78)_100%)]" />
      <div className="absolute inset-x-0 top-0 h-40 bg-[linear-gradient(180deg,#030C16,transparent)]" />
      <div className="absolute inset-x-0 bottom-0 h-40 bg-[linear-gradient(0deg,#030C16,transparent)]" />
    </div>

    <div className="dc-shell relative z-2">
      <h2 className="m-0 max-w-[17ch] text-[clamp(38px,7vw,118px)] font-bold leading-[.96] tracking-[-.042em] text-balance">
        The data is not the problem.
      </h2>

      {/* Stacked below xl in the design's order (intro, cards, quote); from xl
          the cards move into the right-hand column instead of leaving it empty. */}
      <div className="mt-10 grid items-start gap-x-[clamp(48px,6vw,120px)] gap-y-[clamp(56px,7vw,100px)] xl:grid-cols-[minmax(0,5fr)_minmax(0,7fr)]">
        <p className="m-0 max-w-[54ch] text-[clamp(17px,1.5vw,22px)] leading-[1.65] text-mist-2">
          The problem is what sits between the question and the answer:
          petabytes of imagery to store, align and validate before a single
          answer is reached. The complexity only grows when the next question
          arrives — which is why capable organisations end up with one-off
          studies and out-of-date maps.
        </p>

        <div className="grid max-w-[900px] grid-cols-1 gap-x-[clamp(32px,4vw,80px)] gap-y-[clamp(28px,3vw,56px)] md:grid-cols-2 xl:col-start-2 xl:row-span-2 xl:row-start-1 xl:max-w-none">
          {PROBLEMS.map((problem, index) => (
            <Reveal
              key={problem.num}
              delay={index * 90}
              className="border-t border-white/[.18] pt-[22px]"
            >
              <div className="dc-mono mb-[18px] text-[12px] tracking-[.18em] text-mint">
                {problem.num}
              </div>
              <h3 className="mt-0 mb-3 text-[clamp(19px,1.7vw,24px)] font-semibold leading-[1.2] tracking-[-.018em]">
                {problem.title}
              </h3>
              <p className="m-0 text-[17px] leading-[1.7] text-mist-3">
                {problem.body}
              </p>
            </Reveal>
          ))}
        </div>

        <p className="m-0 max-w-[44ch] border-l-2 border-ember pl-[26px] text-[clamp(18px,1.7vw,26px)] leading-[1.45] text-paper xl:col-start-1 xl:row-start-2 xl:self-end">
          Decisions made on old information — inefficiently, at higher cost,
          carrying more risk than necessary.
        </p>
      </div>
    </div>
  </section>
);
